import config from "../../config";
const endpoint = "/opticas";
const isServer = typeof window == "undefined" ? true : false;
let options = {};

if (isServer && config.ENVIROMENT) {
  const https = require("https");

  options = {
    agent: new https.Agent({
      rejectUnauthorized: false,
    }),
  };
}

export const fetchOptica = async (opt={}) => {
  try {
    let optStr = "?";
    if (opt.limit) {
      optStr += `&_limit=${opt.limit}`;
    }
    if (opt.sort) {
      const key = Object.keys(opt.sort)[0];
      optStr += `&_sort=${key}:${opt.sort[key]}`;
    }
    if (opt.start) {
      optStr += `&_start=${opt.start}`;
    }
    if (opt.cond) {
      for (let i = 0; i < Object.keys(opt.cond).length; i++) {
        const key = Object.keys(opt.cond)[i];
        optStr += `&${key}=${opt.cond[key]}`;
      }
    }
    const response = await fetch(
      config.API_HOST + endpoint + optStr,
      options
    ).then((j) => j.json());
    return response;
  } catch (e) {
    console.log(e);
    
  }
};
